import axios from "axios";
import i18n from "@/i18n";

export default {
  baseURL:      process.env.BASE_URL + "api/marketreports",
  adminBaseURL: process.env.BASE_URL + "api/administration/market-reports",

  getFilters(clientId, configurationId, cancelToken) {
    return axios.get(`filters`,
      {
        baseURL: this.baseURL,
        params: {
          "clientId": clientId ?? null,
          "configurationId": configurationId ?? null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getDashboardData(configurationId, brands, cancelToken) {
    return axios.get(`dashboarddata`,
      {
        baseURL: this.baseURL,
        params: {
          "configurationId": configurationId ?? null,
          "brands": brands?.join(",") ?? null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // Market reports - Brand Color Defaults schreiben
  postBrandColorDefaults(clientId, data, cancelToken) {
    return axios.post(`${clientId}/brand-colors/`,
      data,
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // Market reports - Brand and Wave Colors ändern
  postBrandAndWaveColors(configurationId, data, cancelToken) {
    return axios.post(`colors/${configurationId}`,
      data,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },
  
  // Market reports - Configurations / Administration
  getMarketReportsFilters(clientId, cancelToken) {
    return axios.get(`${clientId}/configurations/filters`,
      { 
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getMarketReportsConfigurations(clientId, cancelToken) {
    return axios.get(`${clientId}/configurations`,
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getMarketReportsConfiguration(clientId, configurationId, cancelToken) {
    return axios.get(`${clientId}/configurations/${configurationId}`,
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  deleteMarketReportsConfiguration(configurationId, cancelToken) {
    return axios.delete(`configurations/${configurationId}`,
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  createMarketReportsConfiguration(data, cancelToken) {
    return axios.post(`configurations`,
      this.fixMarketReportsConfigurationWaves(data),
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  fixMarketReportsConfigurationWaves(data) {
    data.waves = data.waves.flatMap(x => 
      typeof x === 'string' ? x.split(',').map(Number) : x
    );
    return data;
  },

  updateMarketReportsConfiguration(data, cancelToken) {
    return axios.patch(`configurations`,
      this.fixMarketReportsConfigurationWaves(data),
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  updateMarketReportsConfigurationWaveDetails(data, cancelToken) {
    return axios.patch(`configurations-wave-details`,
      this.fixMarketReportsConfigurationWaves(data),
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },


  // Publish and Unpublish Market Reports
  postPublishConfiguration(configurationId, cancelToken) {
    return axios.post(`publish/${configurationId}`,
      undefined,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  postUnpublishConfiguration(configurationId, cancelToken) {
    return axios.post(`unpublish/${configurationId}`,
      undefined,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // Generate and download Market Report Powerpoint file
  getPowerpointReportFile(clientId, configurationId,  cancelToken) {
    return axios.get(`generate-powerpoint-report/${clientId}/${configurationId}`,
      {
        baseURL: this.baseURL,
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // Download uploaded Market Report Powerpoint file
  getPowerpointReportDownload(clientId, configurationId,  cancelToken) {
    return axios.get(`download-powerpoint-report/${clientId}/${configurationId}`,
      {
        baseURL: this.baseURL,
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  postPowerpointReportFile(clientId, configurationId, formData, cancelToken) {
    return axios.post(`upload-powerpoint-report/${clientId}/${configurationId}`, formData,
      {
        baseURL: this.baseURL,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  deletePowerpointReportFile(clientId, configurationId,  cancelToken) {
    return axios.delete(`delete-powerpoint-report/${clientId}/${configurationId}`,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  // Post Process Quality Texts and Key Process Steps Texts
  postKpiTexts(configurationId, data, cancelToken) {
    return axios.post(`post-kpi-texts/${configurationId}`,
      data,
      {
        baseURL: this.adminBaseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  postKpiVisibilityForPowerpoint(data, cancelToken) {
    return axios.post(`kpi-visibility-powerpoint`,
      data,
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  }
};